var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "envelope",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16.5,
    viewBox: "0 0 21 16.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1.5,8.67v8.58a3,3,0,0,0,3,3h15a3,3,0,0,0,3-3V8.67l-8.928,5.493a3,3,0,0,1-3.144,0Z",
    transform: "translate(-1.5 -3.75)",
    fill: "#5F6266"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M22.5,6.908V6.75a3,3,0,0,0-3-3H4.5a3,3,0,0,0-3,3v.158l9.714,5.978a1.5,1.5,0,0,0,1.572,0Z",
    transform: "translate(-1.5 -3.75)",
    fill: "#5F6266"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.07cf341b14164f7a90037aa7c336e24a.svg";
export { ForwardRef as ReactComponent };